import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/joy'
import CallIcon from '@mui/icons-material/Call'
import { ClientCall, CallStatus } from '@numeo/types'
import { CallDurationTimer } from './CallDurationTimer'

interface CallInfoProps {
    to: string
    from: string
    call?: ClientCall
}

export const CallInfo: React.FC<CallInfoProps> = ({ to, from, call }) => {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Chip
                    color={call?.status === CallStatus.CONNECTED ? 'success' : 'primary'}
                    size="md"
                    variant="soft"
                    sx={{
                        fontWeight: 'normal',
                    }}
                >
                    <CallDurationTimer startedAt={call?.startedAt} />
                </Chip>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 2 }}>
                <Stack spacing={1} flex={1}>
                    <Typography level="body-md" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        To: <strong>{to}</strong>
                    </Typography>
                    <Typography level="body-md" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        From: <strong>{from}</strong>
                    </Typography>
                </Stack>
                <Typography level="h4" startDecorator={<CallIcon />}>
                    Active ClientCall
                </Typography>
            </Box>
        </>
    )
}
